/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { NavLink, SidebarConfigData } from '@jira/navigation-apps__shared-types/src/types.tsx';

const findLink = (
	arrayOfLinks: NavLink[],
	legacyId: string,
	partialMatch = false,
): NavLink | undefined => {
	if (!Array.isArray(arrayOfLinks)) {
		return undefined;
	}
	for (let i = 0; i < arrayOfLinks.length; i += 1) {
		const link = arrayOfLinks[i];
		if (partialMatch && link.id.indexOf(legacyId) === 0) {
			return link;
		}
		if (link.id === legacyId) {
			return link;
		}

		if (link.links) {
			const linkFound = findLink(link.links, legacyId, partialMatch);

			if (linkFound) {
				return linkFound;
			}
		}
	}

	return undefined;
};

export const getLinkFromSidebar = (
	sidebarConfig: SidebarConfigData,
	legacyId: string,
	partialMatch = false,
): NavLink | undefined =>
	(sidebarConfig &&
		sidebarConfig.product &&
		findLink(sidebarConfig.product.links, legacyId, partialMatch)) ||
	undefined;

export const hasItemInSidebar = (
	sidebarConfig: SidebarConfigData,
	legacyId: string,
	partialMatch?: boolean,
): boolean => Boolean(getLinkFromSidebar(sidebarConfig, legacyId, partialMatch));
